package com.haeyum

import dev.icerock.moko.graphics.Color
import dev.icerock.moko.resources.AssetResource
import dev.icerock.moko.resources.ColorResource
import dev.icerock.moko.resources.FileResource
import dev.icerock.moko.resources.FontResource
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.PluralsResource
import dev.icerock.moko.resources.ResourceContainer
import dev.icerock.moko.resources.StringResource
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public actual object MR {
  private val contentHash: String = "0dd00345d8becb73b97f64b959f72456"

  public actual object strings : ResourceContainer<StringResource> {
    public override fun values(): List<StringResource> = listOf()
  }

  public actual object plurals : ResourceContainer<PluralsResource> {
    public override fun values(): List<PluralsResource> = listOf()
  }

  public actual object images : ResourceContainer<ImageResource> {
    public actual val dora: ImageResource = ImageResource(fileUrl =
        js("require(\"images/dora.png\")") as String, fileName = "dora.png")

    public actual val github_logo: ImageResource = ImageResource(fileUrl =
        js("require(\"images/github_logo.png\")") as String, fileName = "github_logo.png")

    public actual val imposter: ImageResource = ImageResource(fileUrl =
        js("require(\"images/imposter.png\")") as String, fileName = "imposter.png")

    public actual val logo: ImageResource = ImageResource(fileUrl =
        js("require(\"images/logo.png\")") as String, fileName = "logo.png")

    public actual val nunu: ImageResource = ImageResource(fileUrl =
        js("require(\"images/nunu.png\")") as String, fileName = "nunu.png")

    public actual val pangmoo: ImageResource = ImageResource(fileUrl =
        js("require(\"images/pangmoo.png\")") as String, fileName = "pangmoo.png")

    public override fun values(): List<ImageResource> = listOf(dora, github_logo, imposter, logo,
        nunu, pangmoo)
  }

  public actual object fonts : ResourceContainer<FontResource> {
    public override fun values(): List<FontResource> = listOf(Pretendard.regular, Pretendard.black,
        Pretendard.medium, Pretendard.light, Pretendard.extraBold, Pretendard.bold, Pretendard.thin,
        Pretendard.extraLight, Pretendard.semiBold)

    public fun addFontsToPage(): Unit {
      js("require(\"fonts/comhaeyum-generated-declarations.css\")")
    }

    public actual object Pretendard {
      public actual val black: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-Black.otf\")") as String, fontFamily = "Pretendard-Black")

      public actual val bold: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-Bold.otf\")") as String, fontFamily = "Pretendard-Bold")

      public actual val extraBold: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-ExtraBold.otf\")") as String, fontFamily =
          "Pretendard-ExtraBold")

      public actual val extraLight: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-ExtraLight.otf\")") as String, fontFamily =
          "Pretendard-ExtraLight")

      public actual val light: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-Light.otf\")") as String, fontFamily = "Pretendard-Light")

      public actual val medium: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-Medium.otf\")") as String, fontFamily =
          "Pretendard-Medium")

      public actual val regular: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-Regular.otf\")") as String, fontFamily =
          "Pretendard-Regular")

      public actual val semiBold: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-SemiBold.otf\")") as String, fontFamily =
          "Pretendard-SemiBold")

      public actual val thin: FontResource = FontResource(fileUrl =
          js("require(\"fonts/Pretendard-Thin.otf\")") as String, fontFamily = "Pretendard-Thin")
    }
  }

  public actual object files : ResourceContainer<FileResource> {
    public override fun values(): List<FileResource> = listOf()
  }

  public actual object colors : ResourceContainer<ColorResource> {
    public override fun values(): List<ColorResource> = listOf()
  }

  public actual object assets : ResourceContainer<AssetResource> {
    public override fun values(): List<AssetResource> = listOf()
  }
}
